<template>
  <div class="content">
 
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
      <img src="../assets/images/nav_img1.jpg" />
    </div>
    <div class="main">
      <div class="top wow slideInUp" data-wow-duration="0.5s" data-wow-offset="2">
        <div class="top-left">
          <img src="../assets/images/process/top.png" alt  oncontextmenu="return false;"/>
        </div>
        <div class="top-right">
          <div class="form">
            <h2>预&nbsp;约&nbsp;装&nbsp;修</h2>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="15px"
              class="demo-ruleForm"
            >
              <el-form-item label prop="name">
                <el-input v-model="ruleForm.clientname" placeholder="请选输入您的称呼"></el-input>
              </el-form-item>
              <el-form-item label prop="tel">
                <el-input v-model="ruleForm.moblephone" placeholder="请选输入您的电话号码"></el-input>
              </el-form-item>
              <el-form-item label prop="region">
                <VDistpicker
                  :province="ruleForm.clientprovince"
                  :city="ruleForm.clientcity"
                  :area="ruleForm.county"
                  @province="onChangeProvince"
                  @city="onChangeCity"
                  @area="onChangearea"
                ></VDistpicker>
              </el-form-item>
            </el-form>
            <el-button @click="toFreeRegistration" >立即预约</el-button>
          </div>
          <p>
            已有
            <span>{{nubs}}</span>人预约提供服务
          </p>
        </div>
      </div>
      <div class="intrxm wow slideInUp" data-wow-duration="0.5s" data-wow-offset="2">
        <div class="intr">
          <p>桔家云整装赋能平台服务模式</p>
          <p>极致服务流程体系，从毛坯到精装修，90个工作日拎包入住</p>
        </div>
        <div class="left-img">
          <img src="../assets/images/process/providejl.png" alt oncontextmenu="return false;"/>
        </div>
        <div class="right-reason">
          <h1>为什么业主您选择桔家云？</h1>
          <hr style="background-color:#FCB90D;height:2px;width:420px;border:none;float:left;" />
          <br />
          <p
            style="font-size:16px;text-align:left;font-style:italic;color: grey;
            margin:20px 0px;line-height:28px;"
          >当作为小白业主的你陷入信息严重不对称，人员鱼龙混杂的装修行业，一切都会变得很可怕...</p>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item title="保证施工质量" name="1">
              <div>整个装修流程存在很多施工的细节，整个过程和工艺都比较复杂，工人的手艺也存在参差不齐的情况，施工方偷工减料、不按工艺标准施工的情况也频频发生。而桔家云装修监理作为您的私人专家顾问，施工方不敢随意而为，有效的保障装修质量还能避免落入陷阱。</div>
            </el-collapse-item>
            <el-collapse-item title="节省时间和精力" name="2">
              <div>如果没有桔家云装修监理并且您想要确保施工质量，那么业主您就需要隔三差五地往工地跑，从施工到竣工，不仅劳心劳力耗成本，而且如果没有过硬的装修知识做支撑，很难起到监督的作用。</div>
            </el-collapse-item>
            <el-collapse-item title="不花冤枉钱" name="3">
              <div>桔家云装修监理从初期的报价审核到整个装修的过程，提供全程参与并监督。问题早发现，同时也降低了返工成本。提高施工效率。大大降低了客户的装修成本，避免业主多花冤枉钱。</div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="convention wow slideInUp" data-wow-duration="0.5s" data-wow-offset="2">
        <div class="intr">
          <p>施工文明公约</p>
          <p>极致服务流程体系，从毛坯到精装修，90个工作日拎包入住</p>
        </div>
        <el-carousel height="340px" indicator-position="outside">
          <el-carousel-item v-for="(item,index) in msg" :key="index">
            <img :src="item.imgurl" oncontextmenu="return false;"/>
          </el-carousel-item>
        </el-carousel>`
      </div>
      <div class="center wow slideInUp" data-wow-duration="0.5s" data-wow-offset="2">
        <div class="intr">
          <p>装修流程</p>
          <p>极致服务流程体系，从毛坯到精装修，90个工作日拎包入住</p>
        </div>
        <div class="center-img">
          <img src="../assets/images/process/decoration1.png" alt oncontextmenu="return false;"/>
          <img src="../assets/images/process/decoration2.png" alt oncontextmenu="return false;"/>
          <img src="../assets/images/process/decoration3.png" alt oncontextmenu="return false;"/>
        </div>
      </div>
      <div class="process-detail wow slideInUp" data-wow-duration="0.5s" data-wow-offset="2">
        <div class="intr">
          <p>专业化施工工艺标准输出</p>
          <p>极致服务流程体系，从毛坯到精装修，90个工作日拎包入住</p>
        </div>
        <div class="team">
          <div class="tab-title">
            <ul>
              <li @click="cur=0" :class="{active:cur==0}">
                <img src="../assets/images/process/icon/kgys.png" alt oncontextmenu="return false;"/>
                <br />开工仪式
              </li>
              <li @click="cur=1" :class="{active:cur==1}">
                <img src="../assets/images/process/icon/ccgc.png" alt oncontextmenu="return false;"/>
                <br />拆除工程
              </li>
              <li @click="cur=2" :class="{active:cur==2}">
                <img src="../assets/images/process/icon/xjgc.png" alt oncontextmenu="return false;"/>
                <br />新建工程
              </li>
              <li @click="cur=3" :class="{active:cur==3}">
                <img src="../assets/images/process/icon/kgbh.png" alt oncontextmenu="return false;"/>
                <br />开工保护
              </li>
              <li @click="cur=4" :class="{active:cur==4}">
                <img src="../assets/images/process/icon/sdgc.png" alt oncontextmenu="return false;"/>
                <br />水电工程
              </li>
              <li @click="cur=5" :class="{active:cur==5}">
                <img src="../assets/images/process/icon/sdys.png" alt oncontextmenu="return false;"/>
                <br />水电验收
              </li>
              <li @click="cur=6" :class="{active:cur==6}">
                <img src="../assets/images/process/icon/nggc.png" alt oncontextmenu="return false;"/>
                <br />
                <span>泥工工程</span>
              </li>
              <li @click="cur=7" :class="{active:cur==7}">
                <img src="../assets/images/process/icon/mggc.png" alt oncontextmenu="return false;"/>
                <br />木工工程
              </li>
              <li @click="cur=8" :class="{active:cur==8}">
                <img src="../assets/images/process/icon/nmys.png" alt oncontextmenu="return false;"/>
                <br />泥木验收
              </li>
              <li @click="cur=9" :class="{active:cur==9}">
                <img src="../assets/images/process/icon/tlgc.png" alt oncontextmenu="return false;"/>
                <br />涂料工程
              </li>
              <li @click="cur=10" :class="{active:cur==10}">
                <img src="../assets/images/process/icon/tlys.png" alt oncontextmenu="return false;"/>
                <br />涂料验收
              </li>
              <li @click="cur=11" :class="{active:cur==11}">
                <img src="../assets/images/process/icon/azgc.png" alt oncontextmenu="return false;"/>
                <br />安装工程
              </li>
              <li @click="cur=12" :class="{active:cur==12}">
                <img src="../assets/images/process/icon/jgys.png" alt oncontextmenu="return false;"/>
                <br />竣工验收
              </li>
              <li @click="cur=13" :class="{active:cur==13}">
                <img src="../assets/images/process/icon/hbzl.png" alt oncontextmenu="return false;"/>
                <br />环保治理
              </li>
              <li @click="cur=14" :class="{active:cur==14}">
                <img src="../assets/images/process/icon/khjs.png" alt oncontextmenu="return false;"/>
                <br />客户决算
              </li>
              <li @click="cur=15" :class="{active:cur==15}">
                <img src="../assets/images/process/icon/shbx.png" alt oncontextmenu="return false;"/>
                <br />售后保修
              </li>
            </ul>
          </div>
          <div class="tab-content">
            <div v-show="cur==0">
              <img src="../assets/images/process/kaigong.jpg" alt oncontextmenu="return false;"/>
            </div>
            <div v-show="cur==1">
              <img src="../assets/images/process/chaichu1.jpg" alt oncontextmenu="return false;"/>
            </div>
            <div v-show="cur==2">
              <img src="../assets/images/process/rebuild.jpg" alt oncontextmenu="return false;"/>
            </div>
            <div v-show="cur==3">
              <el-carousel
                :interval="4000"
                height="370px"
                arrow="always"
                indicator-position="outside"
              >
                <el-carousel-item v-for="(item,index) in bh" :key="index">
                  <img :src="item.imgurl" oncontextmenu="return false;"/>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="cur==4">
              <el-carousel
                :interval="4000"
                height="370px"
                arrow="always"
                indicator-position="outside"
              >
                <el-carousel-item v-for="(item,index) in sd" :key="index">
                  <img :src="item.imgurl" oncontextmenu="return false;"/>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="cur==5">
              <img src="../assets/images/process/shuidiann.jpg" alt oncontextmenu="return false;"/>
            </div>
            <div v-show="cur==6">
              <el-carousel
                :interval="4000"
                indicator-position="outside"
                height="370px"
                arrow="always"
              >
                <el-carousel-item v-for="(item,index) in ng" :key="index">
                  <img :src="item.imgurl" oncontextmenu="return false;"/>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="cur==7">
              <el-carousel
                :interval="4000"
                indicator-position="outside"
                height="370px"
                arrow="always"
              >
                <el-carousel-item v-for="(item,index) in tm" :key="index">
                  <img :src="item.imgurl" oncontextmenu="return false;"/>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="cur==8">
              <img src="../assets/images/process/ntys.jpg" alt oncontextmenu="return false;"/>
            </div>
            <div v-show="cur==9">
              <el-carousel
                :interval="4000"
                indicator-position="outside"
                height="370px"
                arrow="always"
              >
                <el-carousel-item v-for="(item,index) in tl" :key="index">
                  <img :src="item.imgurl" oncontextmenu="return false;"/>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="cur==10">
              <img src="../assets/images/process/youqi.jpg" alt style="height:400px" oncontextmenu="return false;"/>
            </div>
            <div v-show="cur==11">
              <el-carousel
                :interval="4000"
                indicator-position="outside"
                height="370px"
                arrow="always"
              >
                <el-carousel-item v-for="(item,index) in az" :key="index">
                  <img :src="item.imgurl" oncontextmenu="return false;"/>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="cur==12">
              <img src="../assets/images/process/jungong.jpg" alt oncontextmenu="return false;"/>
            </div>
            <div v-show="cur==13">
              <img src="../assets/images/process/huanjing.jpg" alt oncontextmenu="return false;"/>
            </div>
            <div v-show="cur==14"></div>
            <div v-show="cur==15"></div>
          </div>
        </div>
      </div>
      <!-- <div class="tea">
        <img src="../assets/images/process/team.png" alt />
      </div>-->
      <div class="tool wow slideInUp" data-wow-duration="0.5s" data-wow-offset="2">
        <div class="intr">
          <p>验房工具</p>
          <p>极致服务流程体系，从毛坯到精装修，90个工作日拎包入住</p>
        </div>
        <div class="tool-img">
          <div>
            <img src="../assets/images/process/icon/tool1.png" alt oncontextmenu="return false;"/>
            <br />两米靠尺
          </div>
          <div>
            <img src="../assets/images/process/icon/tool2.png" alt oncontextmenu="return false;"/>
            <br />90度角尺
          </div>
          <div>
            <img src="../assets/images/process/icon/tool3.png" alt oncontextmenu="return false;"/>
            <br />三角插检测器
          </div>
          <div>
            <img src="../assets/images/process/icon/tool4.png" alt oncontextmenu="return false;"/>
            <br />红外检测器
          </div>
        </div>
        <!-- <img src="../assets/images/process/tool.jpg" alt /> -->
      </div>
      <!-- <div class="pro-img">
        <img src="../assets/images/process/pro.png" alt />
      </div> -->
    </div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import BottomFoot from "../components/BottomFoot.vue";
import Rightnav from "../components/Rightnav.vue";
import Freequote from "../components/Freequote.vue";
import VDistpicker from "v-distpicker";
import WOW from "wowjs";
import Tpicker from "../components/Tpicker.vue";
export default {
  components: {
 
    BottomFoot,
    Rightnav,
    VDistpicker,
    Freequote,
    Tpicker
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "桔家云、装修案例、装修参考、整装、婚房、单身公寓、装修效果图、100平、三口之家、儿童房桔家云整装，上千个装修案例实景分享，业主精心总结装修攻略，新中式、简欧、美式等各种风格案例，尽在桔家云整装。"
        }
      ]
    };
  },
  data() {
    return {
      nub: "3",
      cur: 0,
      nubs:"",
      showquote: false,
      topnub: 0,
      msg: [
        { imgurl: require("../assets/images/process/3-01.jpg"), name: "1" },
        { imgurl: require("../assets/images/process/3-02.jpg"), name: "2" },
        { imgurl: require("../assets/images/process/3-03.jpg"), name: "3" },
        { imgurl: require("../assets/images/process/3-04.jpg"), name: "4" },
        { imgurl: require("../assets/images/process/3-05.jpg"), name: "5" },
        { imgurl: require("../assets/images/process/3-05.jpg"), name: "6" }
      ],
      bh: [
        { imgurl: require("../assets/images/process/protect1.jpg"), name: "1" },
        { imgurl: require("../assets/images/process/protect2.jpg"), name: "2" }
      ],
      sd: [
        {
          imgurl: require("../assets/images/process/shuidian1.jpg"),
          name: "1"
        },
        {
          imgurl: require("../assets/images/process/shuidian2.jpg"),
          name: "2"
        },
        {
          imgurl: require("../assets/images/process/shuidian3.jpg"),
          name: "3"
        },
        {
          imgurl: require("../assets/images/process/shuidian4.jpg"),
          name: "4"
        },
        {
          imgurl: require("../assets/images/process/shuidian5.jpg"),
          name: "5"
        },
        { imgurl: require("../assets/images/process/shuidian6.jpg"), name: "6" }
      ],
      ng: [
        { imgurl: require("../assets/images/process/nigong1.jpg"), name: "1" },
        { imgurl: require("../assets/images/process/nigong2.jpg"), name: "2" },
        { imgurl: require("../assets/images/process/nigong3.jpg"), name: "3" },
        { imgurl: require("../assets/images/process/nigong4.jpg"), name: "4" },
        { imgurl: require("../assets/images/process/nigong5.jpg"), name: "5" },
        { imgurl: require("../assets/images/process/nigong6.jpg"), name: "6" }
      ],
      tm: [
        { imgurl: require("../assets/images/process/tumu1.jpg"), name: "1" },
        { imgurl: require("../assets/images/process/tumu2.jpg"), name: "2" },
        { imgurl: require("../assets/images/process/tumu3.jpg"), name: "3" }
      ],
      tl: [
        { imgurl: require("../assets/images/process/tl1.jpg"), name: "1" },
        { imgurl: require("../assets/images/process/tl2.jpg"), name: "2" }
      ],
      az: [
        { imgurl: require("../assets/images/process/az1.jpg"), name: "1" },
        { imgurl: require("../assets/images/process/az2.jpg"), name: "2" },
        { imgurl: require("../assets/images/process/az3.jpg"), name: "3" },
        { imgurl: require("../assets/images/process/az4.jpg"), name: "4" }
      ],
      ruleForm: {
        clientname: "",
        moblephone: "",
        clientprovince: "",
        clientcity: "",
        source: "1",
        county: ""
      },
      rules: {
        clientname: [
          { required: true, message: "请输入您的称呼", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        moblephone: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { min: 7, max: 11, message: "请输入正确电话号码", trigger: "blur" }
        ]
      },
      activeName: "first",
      activeName: '1'
    };
  },
  methods: {
    onChangeProvince(data) {
      this.ruleForm.clientprovince = data.value;
    },
    onChangeCity(data) {
      this.ruleForm.clientcity = data.value;
    },
    onChangearea(data) {
      this.ruleForm.county = data.value;
    },
    getshow(data) {
      //console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    
    // toFreeRegistration() {
    //   this.$router.push({ path: "/FreeRegistration" });
    // },
    toFreeRegistration: async function() {
      if (this.ruleForm.clientname == "") {
        this.$message({
          message: "姓名不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.ruleForm.moblephone == "") {
        this.$message({
          message: "电话号码不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.ruleForm.clientprovince == "") {
        this.$message({
          message: "省份不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.ruleForm.clientcity == "") {
        this.$message({
          message: "市级不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.ruleForm.county == "") {
        this.$message({
          message: "区/县不能为空",
          type: "warning"
        });
        return false;
      }
      // if (/^([\u4e00-\u9fa5]){2,7}$/.test(this.ruleForm.clientname) == false) {
      //   this.$message({
      //     message: "姓名格式不正确",
      //     type: "warning"
      //   });
      //   return false;
      // }
      if (/^1[3-9]\d{9}$/.test(this.ruleForm.moblephone) == false) {
        this.$message({
          message: "电话号码格式不正确",
          type: "warning"
        });
        return false;
      } 
      //  let datas = this.ruleForm;
      // console.log("this.ruleForm", this.ruleForm);
      let data = {
        clientcity: this.ruleForm.clientcity,
        clientname: this.ruleForm.clientname,
        clientprovince: this.ruleForm.clientprovince,
        county: this.ruleForm.county,
        moblephone: this.ruleForm.moblephone,
        source: "1",
        registertype:"3"
      };
      let res = await this.exequy.appointment(data);
      if (res.data.code == 0) {
        this.nubs = res.data.num;
        this.$message({
          message: "预约成功",
          type: "success"
        });
      }
    },
    getnub: async function() {
      let data = {
        registertype:"3"
      }
      let res = await this.exequy.applicants(data);
      this.nubs = res.data.num;
    }
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    }),
      new WOW.WOW().init();
  },
    created: async function() {
    let self = this;
    self.getnub();
  }
};
</script>
<style scoped>
.head {
  width: 99.15%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
}
.form {
  width: 249px;
  margin: 0 auto;
}
.top .top-right .form .el-form-item {
  margin-bottom: 8px;
}
.el-form-item {
  margin-right: 5%;
}
.banane {
  width: 100%;
  height: 340px;
  
}
.banane img {
  width: 100%;
  height: 100%;
}
.top,.intrxm,.convention,.center,.process-detail,.tool{
  margin-bottom:45px;
}
.intr {
  height: 100px;
  border: 1px #e8f2ed solid;
  background-color: rgba(156, 187, 235, 0.075);
}
.intr p:first-child {
  margin: 10px;
  font-size: 29px;
}
.intr p:not(:first-child) {
  font-size: 17px;
  color: #333;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.process-detail {
  background: rgba(156, 188, 235, 0.11);
}
.top {
  height: 374px;
}
.top-right {
  width: 23%;
  height: 363px;
  box-shadow: 7px 7px 5px rgba(202, 202, 202, 0.616);
}
.top-left {
  width: 77%;
}
.top-left img {
  width: 100%;
}
.top-right p {
  font-size: 13px;
}
.top-right span {
  color: #b31d25;
}
.top-left,
.top-right {
  float: left;
}
.el-button {
  width: 88%;
  background: #b31d25;
  margin-top: -3px;
  border: #b31d25 1px solid;
  color: #fff;
}
.convention {
  background: rgba(156, 188, 235, 0.11);
  width: 100%;
}
.convention img {
  width: 97%;
}
.center {
  background: rgba(156, 188, 235, 0.11);
  height: 580px;
}
.center-img{
  margin-top: 2%;
  display: flex;
  justify-content: space-around;
}
.center img {
  width: 430px;
}
.cont {
  height: 400px;
}
/* .process-detail {
  text-align: left;
} */
.team {
  height: 700px;
  width: 100%;
}
.tab-title {
  width: 100%;
  height: 270px;
}
.tab-title ul li {
  list-style: none;
  margin-top: 2%;
  float: left;
  width: 12%;
  line-height: 25px;
  cursor: pointer;
}
.tab-title ul li img {
  margin-bottom: 5px;
}
.tab-title .active {
  color: rgb(64, 117, 196);
  font-size: 18px;
}
.tab-title img.active {
  width: 54px;
}
.tab-content {
  margin-top: 2%;
  width: 100%;
  float: left;
  margin: 0 auto;
}
.tool {
  width: 100%;
  height: 460px;
  background: rgba(156, 188, 235, 0.11);
}
.tool img {
  width: 100%;
}
.tool-img {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.tool-img div {
  color: #656666;
  line-height: 25px;
  margin-top: 4%;
  width: 13%;
}
.pro-img {
  background: rgba(156, 188, 235, 0.11);
  width: 100%;
  height: 480px;
  margin-bottom: 3%;
}
.pro-img img {
  margin: 0 auto;
  margin-top: 2%;
}
.intrxm {
  width: 100%;
  height: 650px;
  background: rgba(156, 188, 235, 0.11);
}
.intrxm >>> .el-collapse {
  border: 0;
}
.intrxm >>> .el-collapse-item__header {
  border-radius: 20px;
  padding-left: 25px;
  margin-bottom: 7px;
  font-size: 17px;
  color: rgb(112, 112, 112);
}
.intrxm >>> .el-collapse-item__header.is-active {
  color: #2c3e50;
  font-weight: bolder;
}
.intrxm >>> .el-icon-arrow-right.is-active {
  color: rgb(252, 181, 2);
}
.intrxm >>> .el-collapse-item__content {
  text-align: left;
  color: rgb(112, 112, 112);
  background: rgba(156, 188, 235, 0.11);
  font-size: 15px;
  padding-top: 3%;
  padding-left: 2%;
}
.intrxm >>> .el-collapse-item__wrap {
  width: 490px;
  margin: 0 auto;
  border: 0;
}
.left-img,
.right-reason {
  float: left;
}
.right-reason h1{
  text-align:center; 
  margin-bottom:5px;
  margin-top:30px;
  width: 420px;
  height: 50px;
  color: rgb(68, 68, 68);
  /* background-color:rgb(255, 160, 71); */
  border-radius: 6px;
  border:1px solid #cececea1;
 background-image: linear-gradient(to bottom,rgba(236, 124, 31, 0.781) 0%, rgba(240, 144, 60, 0.829) 50%,rgba(255, 177, 103, 0.699) 100%); 
 box-shadow: 4px 4px 5px #adacaca1 ;
}
.left-img {
  margin-top: 2%;
  width: 55%;
}
.left-img img{
  margin: 0 auto;
  height: 485px;
}
.right-reason {
  width: 40%;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.liname {
  font-size: 16px;
  text-align: left;
  color: #827c7c;
}
.tab-content >>> .el-carousel__arrow {
  height: 70px;
  width: 70px;
  font-size: 35px;
}
.convention >>> .el-carousel__arrow {
  height: 70px;
  width: 70px;
  font-size: 35px;
}
.form >>> .distpicker-address-wrapper select:first-child {
  width: 222px;
}
.form >>> .distpicker-address-wrapper select:not(:first-child) {
  width: 108px;
}
.convention >>> .el-carousel__indicator {
  width: 55px;
}
.content {
  width: 100%;
}
</style>
